import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function Button({
  children,
  className = '',
  onClick,
  href
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (onClick) {
      onClick();
    } else if (!href || href.startsWith('#')) {
      e.preventDefault();
      const targetId = href ? href.substring(1) : 'comprar';
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  const baseClasses = 'group relative inline-flex items-center justify-center gap-2 rounded-full bg-burgundy-600 px-8 py-4 text-lg font-bold text-white shadow-glow transition-all hover:-translate-y-1 hover:bg-burgundy-500 hover:shadow-[0_0_30px_rgba(139,44,44,0.5)] active:translate-y-0 w-full sm:w-auto overflow-hidden';
  const content = <>
      <span className="relative z-10 flex items-center gap-2" data-id="element-41">
        {children}
        <ChevronRight className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-42" />
      </span>
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition-transform duration-700 group-hover:translate-x-full" data-id="element-43" />
    </>;
  if (href && !href.startsWith('#')) {
    return <motion.a whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} href={href} onClick={handleClick} className={`${baseClasses} ${className}`} target="_blank" rel="noopener noreferrer" data-id="element-44">
        {content}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`${baseClasses} ${className}`} data-id="element-45">
      {content}
    </motion.button>;
}